/**
 * features/create-organization/model/schema — Zod schema for org creation form.
 */

import { z } from 'zod';

export const createOrganizationSchema = z.object({
  name: z
    .string()
    .min(1, 'create.error.nameRequired')
    .min(2, 'create.error.nameTooShort')
    .max(100, 'create.error.nameTooLong')
    .trim(),
});

export type CreateOrganizationFormValues = z.infer<typeof createOrganizationSchema>;
